import { Alert, Button, Card, CardContent, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, GridLegacy as Grid, Typography } from '@mui/material'
import { useContext, useEffect, useState } from "react"
import { Controller, useForm } from "react-hook-form";
import { InputWithLabel, SelectInputWithLabel } from "../form/custom-imputs";
import { AxiosInstance, DialogType } from "../../utils/constants";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { ActionTypes, AppContext } from "../../store/AppStore";
import { GetStatusAlert } from "../../utils/constants";


const schema = yup.object({
    unidad_medida:yup.string(),
    precio:yup.number().min(1),
    cantidad:yup.number().min(1)
});

export const ModalNegociacion = ({
    cod_cotizacion,
    isLoked=false,
    cancelOption,
    opened=false,
     
})=>{
    const { handleSubmit, control,formState:{errors}, reset,setValue,set } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            calidad:null,
            unidad_medida:null,
            precio:null,
            cantidad:null
        },
        precio:1000
      });

      const [calidades,setCalidades] = useState([]);
      const [unidadesMedidas,setUnidadesMedidas] = useState([]);
      const [infoBase,setInfoBase] = useState({});
      const { dispatch, store } = useContext(AppContext);


    useEffect(()=>{

        if ( cod_cotizacion ){

            AxiosInstance.post("cotizaciones/consultar-negociacion",{
                cod_cotizacion 
            }).then(({data})=>{
                setCalidades(data.value.calidades);
                setUnidadesMedidas(data.value.unidades_medidas);
                setInfoBase({...data.value});
                Object.keys(data.value).forEach(keyItem=>{
                  
                    setValue(keyItem,["calidad","unidad_medida"].includes(keyItem)?data.value[keyItem].value:data.value[keyItem]);
                });
               

            }).catch(err=>{

            });

        }

    },[cod_cotizacion]);


    const ReenviarNegociacion = (data)=>{
        dispatch({
            type: ActionTypes.setLoadingPage,
            data: true
        });

        AxiosInstance.post("cotizaciones/change-negociacion-status",{
            cod_negociacion:infoBase.cod_negociacion,
            payload:{
                estado:"POR CONFIRMAR",
                cantidad:data.cantidad,
                cod_unidad_medida:data.unidad_medida,
                precio_unitario:data.precio
            }
        }).then(({data})=>{

            cancelOption();
            dispatch({
                type: ActionTypes.setModalInfo,
                data: {
                  title: "Negociacion reenviada",
                  message: "La negociacion ha sido reenviada utilice el mismo link para confirmar la negociacion",
                  type: DialogType.exitoso,
                  isVisible: true
                }
              });

        }).catch(err=>{

            dispatch({
                type: ActionTypes.setModalInfo,
                data: {
                  title: "Error al registrar la negociacion",
                  message: "Error interno en el servidor",
                  type: DialogType.peligro,
                  isVisible: true
                }
              });
            
        }).finally(()=>{

            dispatch({
                type: ActionTypes.setLoadingPage,
                data: false
            });

        });
    }


    const onSubmit = (data) => {

        if ( infoBase.estado == 'RECHAZADA' ){
            ReenviarNegociacion(data);
            return;
        }
        dispatch({
            type: ActionTypes.setLoadingPage,
            data: true
          });
        console.log(data);
        AxiosInstance.post("cotizaciones/enviar-negociacion",{
            ...data
        }).then(({data})=>{

            cancelOption();
            dispatch({
                type: ActionTypes.setModalInfo,
                data: {
                  title: "Negociacion enviada",
                  message: "La negociacion ha sido registrada y fue notificada al proveedor",
                  type: DialogType.exitoso,
                  isVisible: true
                }
              });

        }).catch(err=>{

            dispatch({
                type: ActionTypes.setModalInfo,
                data: {
                  title: "Error al registrar la negociacion",
                  message: "Error interno en el servidor",
                  type: DialogType.peligro,
                  isVisible: true
                }
              });
            
        }).finally(()=>{

            dispatch({
                type: ActionTypes.setLoadingPage,
                data: false
            });

        });

    };

    
    return (
        <Dialog
        open={opened}
        >
            <DialogTitle>Negociacion Cotizacion N° {cod_cotizacion}</DialogTitle>

            
            
            <DialogContent>

                <Card>
                    <CardContent>
                        <Typography>Producto: {infoBase?.producto?.label}</Typography>
                        
                    </CardContent>
                </Card>

                    <form onSubmit={ handleSubmit(onSubmit) }  >
                     <Grid container >
                        <Grid  item sx={12} sm={12} >
                            <Controller 
                            name="calidad"
                            control={control}
                             
                            rules={{ required: true }}
                            render={({ field }) => <SelectInputWithLabel 
                            disabled={true}
                            label='Calidad del producto'
                            items={calidades}  
                            {...field} />}
                            />
                        </Grid>
                       
                        <Grid  item sx={12} sm={12} >
                            <Controller 
                            name="unidad_medida"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => <SelectInputWithLabel 
                            label='Unidad de medida'
                            errorMessage={errors["unidad_medida"]?.message}
                            items={unidadesMedidas}  
                            {...field} />}
                            />
                        </Grid>

                        <Grid  item sx={12} sm={12} >
                            <Controller 
                            name="precio"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => <InputWithLabel 
                            type="number"
                            label='Precio'
                            items={calidades}  
                            errorMessage={errors["precio"]?.message}
                            {...field} />}
                            />
                        </Grid>
                        <Grid  item sx={12} sm={12} >
                            <Controller 
                            name="cantidad"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => <InputWithLabel 
                            type="number"
                            label='Cantidad'
                            errorMessage={errors["cantidad"]?.message}
                            items={calidades}  
                            {...field} />}
                            />
                        </Grid>
                        <Grid  item sx={12} sm={12} >
                            <Alert severity={"info"} >
                                {infoBase.estado}
                            </Alert>
                        </Grid>

                     </Grid>
                     <DialogActions>
                     <Button onClick={cancelOption} variant="contained" color="secondary"  >Cerrar</Button>
                        {
                           infoBase.estado === 'RECHAZADA' &&
                           <Button type="submit"  variant="contained" color="primary"  >Reenviar negociacion</Button>
                        }
                        <Button disabled={isLoked || ["POR CONFIRMAR","CONFIRMADA","RECHAZADA"].includes(infoBase.estado)} type="submit"  variant="contained" color="primary"  >Enviar negociacion</Button>
                     </DialogActions>
                        
                    </form>

            </DialogContent>
        </Dialog>
    )
}